module.exports = __webpack_public_path__ + "static/media/go-share-dark.85d885cb.svg";